import React, { useState } from 'react';
import {
  Box,
  Container,
  Paper,
  Typography,
  Grid,
  Card,
  CardContent,
  CardHeader,
  TextField,
  Button,
  Switch,
  FormControlLabel,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Avatar,
  IconButton,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  ListItemSecondaryAction,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  Snackbar,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Badge
} from '@mui/material';
import {
  Settings as SettingsIcon,
  Store as StoreIcon,
  Person as PersonIcon,
  Notifications as NotificationsIcon,
  Payment as PaymentIcon,
  LocalShipping as ShippingIcon,
  Security as SecurityIcon,
  Language as LanguageIcon,
  Edit as EditIcon,
  PhotoCamera as PhotoCameraIcon,
  Save as SaveIcon,
  Cancel as CancelIcon,
  Add as AddIcon,
  Delete as DeleteIcon,
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
  LocationOn as LocationIcon,
  Schedule as ScheduleIcon,
  AttachMoney as MoneyIcon,
  CreditCard as CreditCardIcon,
  AccountBalance as BankIcon,
  PhoneAndroid as MobileIcon,
  Verified as VerifiedIcon,
  Warning as WarningIcon,
  Language as WebIcon,
  CalendarToday as CalendarIcon,
  Image as ImageIcon,
  CameraAlt as CameraAltIcon
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: theme.spacing(2),
  boxShadow: '0 4px 20px 0 rgba(0,0,0,0.12)',
  marginBottom: theme.spacing(3),
}));

const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: theme.spacing(2),
  border: '1px solid #e0e0e0',
  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  transition: 'all 0.3s ease',
  '&:hover': {
    boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
    transform: 'translateY(-2px)'
  }
}));

const Settings = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [openPasswordDialog, setOpenPasswordDialog] = useState(false);
  const [openPaymentDialog, setOpenPaymentDialog] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  // Settings State
  const [storeSettings, setStoreSettings] = useState({
    storeName: 'গ্রামীণ বাজার',
    storeDescription: 'তাজা ও অর্গানিক পণ্যের বিশ্বস্ত দোকান',
    storeAddress: '১২ মেইন রোড, ঢাকা ১২০০',
    storePhone: '০১৭১২৩৪৫৬৭২',
    storeEmail: 'info@grameenbazar.com',
    websiteUrl: 'https://grameenbazar.com',
    openTime: '08:00',
    closeTime: '22:00',
    weeklySchedule: {
      saturday: { isOpen: true, openTime: '08:00', closeTime: '22:00' },
      sunday: { isOpen: true, openTime: '08:00', closeTime: '22:00' },
      monday: { isOpen: true, openTime: '08:00', closeTime: '22:00' },
      tuesday: { isOpen: true, openTime: '08:00', closeTime: '22:00' },
      wednesday: { isOpen: true, openTime: '08:00', closeTime: '22:00' },
      thursday: { isOpen: true, openTime: '08:00', closeTime: '22:00' },
      friday: { isOpen: false, openTime: '08:00', closeTime: '22:00' }
    },
    deliveryRadius: 10,
    minOrderAmount: 100,
    deliveryCharge: 50,
    isOpen: true,
    acceptsOnlinePayment: true,
    district: 'ঢাকা',
    upazilla: 'ধানমন্ডি',
    bazar: 'নিউ মার্কেট'
  });

  const [profileSettings, setProfileSettings] = useState({
    ownerName: 'মোহাম্মদ করিম',
    ownerPhone: '০১৭১২৩৪৫৬৭২',
    ownerEmail: 'karim@grameenbazar.com',
    nidNumber: '১২৩৪৫৬১২৩৪৫৬',
    tradeLicense: 'TL-123456789',
    bankAccount: '১২৩৪৫৬৭৮৯০'
  });

  const [notificationSettings, setNotificationSettings] = useState({
    emailNotifications: true,
    smsNotifications: true,
    pushNotifications: true,
    orderNotifications: true,
    paymentNotifications: true,
    stockAlerts: true,
    customerMessages: true,
    promotionalEmails: false
  });

  const [paymentMethods, setPaymentMethods] = useState([
    { id: 1, type: 'bkash', number: '০১৭১২৩৪৫৬৭২', status: 'verified', primary: true },
    { id: 2, type: 'nagad', number: '০১৭১২৩৪৫৬৭২', status: 'verified', primary: false },
    { id: 3, type: 'bank', accountNumber: '১২৩৪৫৬৭৮৯০', bankName: 'Dutch Bangla Bank', status: 'pending', primary: false }
  ]);

  const [locationData] = useState({
    districts: [
      'ঢাকা', 'চট্টগ্রাম', 'রাজশাহী', 'খুলনা', 'বরিশাল', 'সিলেট', 'রংপুর', 'ময়মনসিংহ',
      'গাজীপুর', 'নারায়ণগঞ্জ', 'কুমিল্লা', 'ফরিদপুর', 'কিশোরগঞ্জ', 'মাদারীপুর', 'নরসিংদী'
    ],
    upazillas: {
      'ঢাকা': ['ধানমন্ডি', 'গুলশান', 'বনানী', 'মিরপুর', 'উত্তরা', 'রমনা', 'তেজগাঁও', 'ওয়ারী', 'মতিঝিল', 'পুরান ঢাকা'],
      'চট্টগ্রাম': ['চট্টগ্রাম সদর', 'হাটহাজারী', 'রাউজান', 'পটিয়া', 'সীতাকুণ্ড', 'মিরসরাই', 'ফটিকছড়ি', 'রাঙ্গুনিয়া'],
      'রাজশাহী': ['রাজশাহী সদর', 'বাগমারা', 'চারঘাট', 'দুর্গাপুর', 'গোদাগাড়ী', 'মোহনপুর', 'পবা', 'পুঠিয়া', 'তানোর'],
      'খুলনা': ['খুলনা সদর', 'বটিয়াঘাটা', 'দাকোপ', 'ডুমুরিয়া', 'ফকিরহাট', 'কয়রা', 'পাইকগাছা', 'রূপসা', 'তেরখাদা'],
      'গাজীপুর': ['গাজীপুর সদর', 'কালিয়াকৈর', 'কাপাসিয়া', 'শ্রীপুর', 'টঙ্গী'],
      'নারায়ণগঞ্জ': ['নারায়ণগঞ্জ সদর', 'আড়াইহাজার', 'বন্দর', 'রূপগঞ্জ', 'সোনারগাঁ']
    },
    bazars: {
      'ধানমন্ডি': ['নিউ মার্কেট', 'চন্দ্রিমা মার্কেট', 'গরীব-ই-নেওয়াজ মার্কেট', 'ধানমন্ডি বাজার'],
      'গুলশান': ['গুলশান ১ বাজার', 'গুলশান ২ বাজার', 'উত্তরা টাউন সেন্টার', 'বসুন্ধরা সিটি'],
      'বনানী': ['বনানী বাজার', 'সুপার মার্কেট', 'কনকর্ড টাওয়ার', 'রোড নং ১১ বাজার'],
      'মিরপুর': ['মিরপুর ১ বাজার', 'মিরপুর ১০ বাজার', 'শাহ আলী বাজার', 'কল্যাণপুর বাজার'],
      'উত্তরা': ['উত্তরা টাউন সেন্টার', 'আজমপুর বাজার', 'সেক্টর ৩ বাজার', 'সেক্টর ৭ বাজার'],
      'তেজগাঁও': ['তেজগাঁও বাজার', 'ইন্ডাস্ট্রিয়াল এরিয়া বাজার', 'কলাবাগান বাজার'],
      'চট্টগ্রাম সদর': ['চট্টগ্রাম নিউ মার্কেট', 'রিয়াজউদ্দিন বাজার', 'কদম মোবারক বাজার'],
      'রাজশাহী সদর': ['শাহ মখদুম মার্কেট', 'রেলওয়ে মার্কেট', 'গোদাগাড়ী বাজার'],
      'খুলনা সদর': ['খুলনা নিউ মার্কেট', 'দাদখানী বাজার', 'রূপসা বাজার'],
      'গাজীপুর সদর': ['গাজীপুর চৌরাস্তা বাজার', 'চন্দনা বাজার', 'টঙ্গী বাজার'],
      'নারায়ণগঞ্জ সদর': ['চাষাড়া বাজার', 'সিদ্ধিরগঞ্জ বাজার', 'নারায়ণগঞ্জ সদর বাজার']
    }
  });

  // Get available upazillas based on selected district
  const getAvailableUpazillas = () => {
    return locationData.upazillas[storeSettings.district] || [];
  };

  // Get available bazars based on selected upazilla
  const getAvailableBazars = () => {
    return locationData.bazars[storeSettings.upazilla] || [];
  };

  // Handle district change and reset dependent fields
  const handleDistrictChange = (newDistrict) => {
    setStoreSettings(prev => ({
      ...prev,
      district: newDistrict,
      upazilla: '', // Reset upazilla when district changes
      bazar: '' // Reset bazar when district changes
    }));
  };

  // Handle upazilla change and reset dependent fields
  const handleUpazillaChange = (newUpazilla) => {
    setStoreSettings(prev => ({
      ...prev,
      upazilla: newUpazilla,
      bazar: '' // Reset bazar when upazilla changes
    }));
  };

  // Handle weekly schedule changes
  const handleScheduleChange = (day, field, value) => {
    setStoreSettings(prev => ({
      ...prev,
      weeklySchedule: {
        ...prev.weeklySchedule,
        [day]: {
          ...prev.weeklySchedule[day],
          [field]: value
        }
      }
    }));
  };

  // Get day names in Bengali
  const getDayName = (day) => {
    const dayNames = {
      saturday: 'শনিবার',
      sunday: 'রবিবার',
      monday: 'সোমবার',
      tuesday: 'মঙ্গলবার',
      wednesday: 'বুধবার',
      thursday: 'বৃহস্পতিবার',
      friday: 'শুক্রবার'
    };
    return dayNames[day] || day;
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleStoreSettingChange = (field, value) => {
    setStoreSettings(prev => ({ ...prev, [field]: value }));
  };

  const handleProfileSettingChange = (field, value) => {
    setProfileSettings(prev => ({ ...prev, [field]: value }));
  };

  const handleNotificationChange = (field) => {
    setNotificationSettings(prev => ({ ...prev, [field]: !prev[field] }));
  };

  const handleSaveSettings = (type) => {
    setSnackbar({
      open: true,
      message: `${type} সেটিংস সফলভাবে সংরক্ষিত হয়েছে`,
      severity: 'success'
    });
  };

  const TabPanel = ({ children, value, index }) => (
    <div hidden={value !== index}>
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );

  const getPaymentMethodIcon = (type) => {
    switch (type) {
      case 'bkash': return '📱';
      case 'nagad': return '💳';
      case 'bank': return '🏦';
      default: return '💰';
    }
  };

  const getPaymentMethodName = (type) => {
    switch (type) {
      case 'bkash': return 'বিকাশ';
      case 'nagad': return 'নগদ';
      case 'bank': return 'ব্যাংক অ্যাকাউন্ট';
      default: return 'অন্যান্য';
    }
  };

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      {/* Page Header */}
      <StyledPaper>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Avatar sx={{ bgcolor: 'primary.main', mr: 2, width: 56, height: 56 }}>
              <SettingsIcon sx={{ fontSize: 32 }} />
            </Avatar>
            <Box>
              <Typography variant="h4" sx={{ fontWeight: 600, color: 'primary.main' }}>
                সেটিংস
              </Typography>
              <Typography variant="body1" color="text.secondary">
                আপনার দোকান ও অ্যাকাউন্টের সেটিংস পরিচালনা করুন
              </Typography>
            </Box>
          </Box>
          
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button
              variant="outlined"
              startIcon={<SaveIcon />}
              onClick={() => handleSaveSettings('সকল')}
            >
              সব সংরক্ষণ করুন
            </Button>
            <Button
              variant="contained"
              startIcon={<VerifiedIcon />}
              color="success"
            >
              ভেরিফাইড অ্যাকাউন্ট
            </Button>
          </Box>
        </Box>
      </StyledPaper>

      {/* Settings Tabs */}
      <StyledPaper>
        <Tabs value={activeTab} onChange={handleTabChange} variant="scrollable" scrollButtons="auto">
          <Tab icon={<StoreIcon />} label="দোকানের তথ্য" />
          <Tab icon={<PersonIcon />} label="প্রোফাইল" />
          <Tab icon={<NotificationsIcon />} label="নোটিফিকেশন" />
          <Tab icon={<PaymentIcon />} label="পেমেন্ট" />
          <Tab icon={<ShippingIcon />} label="ডেলিভারি" />
          <Tab icon={<SecurityIcon />} label="নিরাপত্তা" />
        </Tabs>

        {/* Store Information Tab */}
        <TabPanel value={activeTab} index={0}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={8}>
              <StyledCard>
                <CardHeader 
                  title="দোকানের বেসিক তথ্য"
                  avatar={<Avatar sx={{ bgcolor: 'primary.main' }}><StoreIcon /></Avatar>}
                />
                <CardContent>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="দোকানের নাম"
                        value={storeSettings.storeName}
                        onChange={(e) => handleStoreSettingChange('storeName', e.target.value)}
                      />
                    </Grid>
                    
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="ফোন নম্বর"
                        value={storeSettings.storePhone}
                        onChange={(e) => handleStoreSettingChange('storePhone', e.target.value)}
                        InputProps={{
                          startAdornment: <PhoneIcon sx={{ mr: 1, color: 'text.secondary' }} />
                        }}
                      />
                    </Grid>
                    
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        multiline
                        rows={3}
                        label="দোকানের বিবরণ"
                        value={storeSettings.storeDescription}
                        onChange={(e) => handleStoreSettingChange('storeDescription', e.target.value)}
                      />
                    </Grid>
                    
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="দোকানের ঠিকানা"
                        value={storeSettings.storeAddress}
                        onChange={(e) => handleStoreSettingChange('storeAddress', e.target.value)}
                        InputProps={{
                          startAdornment: <LocationIcon sx={{ mr: 1, color: 'text.secondary' }} />
                        }}
                      />
                    </Grid>
                    
                    {/* Location Selection */}
                    <Grid item xs={12}>
                      <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600, color: 'text.primary' }}>
                        📍 দোকানের অবস্থান নির্বাচন করুন
                      </Typography>
                    </Grid>
                    
                    <Grid item xs={12} md={4}>
                      <FormControl fullWidth>
                        <InputLabel>জেলা</InputLabel>
                        <Select
                          value={storeSettings.district}
                          onChange={(e) => handleDistrictChange(e.target.value)}
                          label="জেলা"
                          MenuProps={{ disableScrollLock: true }}
                        >
                          {locationData.districts.map((district) => (
                            <MenuItem key={district} value={district}>
                              {district}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    
                    <Grid item xs={12} md={4}>
                      <FormControl fullWidth disabled={!storeSettings.district}>
                        <InputLabel>উপজেলা</InputLabel>
                        <Select
                          value={storeSettings.upazilla}
                          onChange={(e) => handleUpazillaChange(e.target.value)}
                          label="উপজেলা"
                          MenuProps={{ disableScrollLock: true }}
                        >
                          {getAvailableUpazillas().map((upazilla) => (
                            <MenuItem key={upazilla} value={upazilla}>
                              {upazilla}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    
                    <Grid item xs={12} md={4}>
                      <FormControl fullWidth disabled={!storeSettings.upazilla}>
                        <InputLabel>বাজার</InputLabel>
                        <Select
                          value={storeSettings.bazar}
                          onChange={(e) => handleStoreSettingChange('bazar', e.target.value)}
                          label="বাজার"
                          MenuProps={{ disableScrollLock: true }}
                        >
                          {getAvailableBazars().map((bazar) => (
                            <MenuItem key={bazar} value={bazar}>
                              {bazar}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="ইমেইল"
                        type="email"
                        value={storeSettings.storeEmail}
                        onChange={(e) => handleStoreSettingChange('storeEmail', e.target.value)}
                        InputProps={{
                          startAdornment: <EmailIcon sx={{ mr: 1, color: 'text.secondary' }} />
                        }}
                      />
                    </Grid>
                    
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="ওয়েবসাইট URL"
                        type="url"
                        value={storeSettings.websiteUrl}
                        onChange={(e) => handleStoreSettingChange('websiteUrl', e.target.value)}
                        placeholder="https://example.com"
                        InputProps={{
                          startAdornment: <WebIcon sx={{ mr: 1, color: 'text.secondary' }} />
                        }}
                        helperText="আপনার দোকানের ওয়েবসাইট লিংক (ঐচ্ছিক)"
                      />
                    </Grid>
                    
                    <Grid item xs={12} md={6}>
                      <FormControlLabel
                        control={
                          <Switch 
                            checked={storeSettings.isOpen}
                            onChange={(e) => handleStoreSettingChange('isOpen', e.target.checked)}
                          />
                        }
                        label="দোকান খোলা আছে"
                      />
                    </Grid>
                  </Grid>

                  {/* Opening Hours Section */}
                  <Box sx={{ mt: 4 }}>
                    <Typography variant="h6" sx={{ mb: 3, fontWeight: 600, color: 'text.primary', display: 'flex', alignItems: 'center' }}>
                      <CalendarIcon sx={{ mr: 1, color: 'info.main' }} />
                      খোলার সময়
                    </Typography>
                    
                    <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600, color: 'text.secondary' }}>
                      📅 সাপ্তাহিক সময়সূচী
                    </Typography>
                    
                    {Object.entries(storeSettings.weeklySchedule).map(([day, schedule]) => (
                      <Box key={day} sx={{ mb: 2, p: 2, bgcolor: 'grey.50', borderRadius: 2 }}>
                        {/* First Row - Day and Open/Close Toggle */}
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                          <Typography variant="body1" sx={{ fontWeight: 600 }}>
                            {getDayName(day)}
                          </Typography>
                          <FormControlLabel
                            control={
                              <Switch
                                size="small"
                                checked={schedule.isOpen}
                                onChange={(e) => handleScheduleChange(day, 'isOpen', e.target.checked)}
                              />
                            }
                            label={schedule.isOpen ? 'খোলা' : 'বন্ধ'}
                            sx={{ m: 0 }}
                          />
                        </Box>
                        
                        {/* Second Row - Time Fields */}
                        {schedule.isOpen && (
                          <Grid container spacing={2}>
                            <Grid item xs={6}>
                              <TextField
                                fullWidth
                                size="small"
                                label="খোলার সময়"
                                type="time"
                                value={schedule.openTime}
                                onChange={(e) => handleScheduleChange(day, 'openTime', e.target.value)}
                                InputLabelProps={{ shrink: true }}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <TextField
                                fullWidth
                                size="small"
                                label="বন্ধের সময়"
                                type="time"
                                value={schedule.closeTime}
                                onChange={(e) => handleScheduleChange(day, 'closeTime', e.target.value)}
                                InputLabelProps={{ shrink: true }}
                              />
                            </Grid>
                          </Grid>
                        )}
                      </Box>
                    ))}
                    
                    <Alert severity="info" sx={{ mt: 2, fontSize: '0.875rem' }}>
                      💡 প্রতিদিনের জন্য আলাদা সময় নির্ধারণ করুন
                    </Alert>
                  </Box>
                  
                  <Box sx={{ mt: 3, display: 'flex', gap: 2 }}>
                    <Button 
                      variant="contained" 
                      startIcon={<SaveIcon />}
                      onClick={() => handleSaveSettings('দোকানের তথ্য')}
                    >
                      সংরক্ষণ করুন
                    </Button>
                    <Button variant="outlined" startIcon={<CancelIcon />}>
                      বাতিল
                    </Button>
                  </Box>
                </CardContent>
              </StyledCard>
            </Grid>

            <Grid item xs={12} md={4}>
              <StyledCard>
                <CardHeader 
                  title="দোকানের ছবি" 
                  avatar={<Avatar sx={{ bgcolor: 'secondary.main' }}><ImageIcon /></Avatar>}
                />
                <CardContent>
                  {/* Profile Photo Section */}
                  <Box sx={{ textAlign: 'center', mb: 3 }}>
                    <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600 }}>
                      প্রোফাইল ছবি
                    </Typography>
                    <Avatar
                      sx={{ 
                        width: 100, 
                        height: 100, 
                        mx: 'auto', 
                        mb: 2,
                        fontSize: 40,
                        bgcolor: 'primary.main'
                      }}
                    >
                      <StoreIcon sx={{ fontSize: 50 }} />
                    </Avatar>
                    
                    <Button
                      variant="outlined"
                      startIcon={<PhotoCameraIcon />}
                      size="small"
                      fullWidth
                      sx={{ mb: 1 }}
                    >
                      প্রোফাইল ছবি পরিবর্তন
                    </Button>
                  </Box>

                  <Divider sx={{ my: 2 }} />

                  {/* Cover Photo Section */}
                  <Box sx={{ textAlign: 'center' }}>
                    <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600 }}>
                      কভার ছবি
                    </Typography>
                    <Box
                      sx={{
                        width: '100%',
                        height: 80,
                        bgcolor: 'grey.100',
                        borderRadius: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mb: 2,
                        border: '2px dashed',
                        borderColor: 'grey.300'
                      }}
                    >
                      <CameraAltIcon sx={{ fontSize: 30, color: 'grey.500' }} />
                    </Box>
                    
                    <Button
                      variant="outlined"
                      startIcon={<ImageIcon />}
                      size="small"
                      fullWidth
                      sx={{ mb: 2 }}
                    >
                      কভার ছবি আপলোড করুন
                    </Button>
                  </Box>
                  
                  <Typography variant="caption" color="text.secondary" sx={{ display: 'block', textAlign: 'center' }}>
                    সর্বোচ্চ ৫এমবি, JPG/PNG ফরম্যাট
                  </Typography>
                </CardContent>
              </StyledCard>


            </Grid>
          </Grid>
        </TabPanel>

        {/* Profile Tab */}
        <TabPanel value={activeTab} index={1}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <StyledCard>
                <CardHeader 
                  title="ব্যক্তিগত তথ্য"
                  avatar={<Avatar sx={{ bgcolor: 'success.main' }}><PersonIcon /></Avatar>}
                />
                <CardContent>
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="মালিকের নাম"
                        value={profileSettings.ownerName}
                        onChange={(e) => handleProfileSettingChange('ownerName', e.target.value)}
                      />
                    </Grid>
                    
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="ফোন নম্বর"
                        value={profileSettings.ownerPhone}
                        onChange={(e) => handleProfileSettingChange('ownerPhone', e.target.value)}
                      />
                    </Grid>
                    
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="ইমেইল"
                        type="email"
                        value={profileSettings.ownerEmail}
                        onChange={(e) => handleProfileSettingChange('ownerEmail', e.target.value)}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </StyledCard>
            </Grid>

            <Grid item xs={12} md={6}>
              <StyledCard>
                <CardHeader 
                  title="ব্যবসায়িক তথ্য"
                  avatar={<Avatar sx={{ bgcolor: 'warning.main' }}><VerifiedIcon /></Avatar>}
                />
                <CardContent>
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="জাতীয় পরিচয়পত্র নম্বর"
                        value={profileSettings.nidNumber}
                        onChange={(e) => handleProfileSettingChange('nidNumber', e.target.value)}
                      />
                    </Grid>
                    
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="ট্রেড লাইসেন্স নম্বর"
                        value={profileSettings.tradeLicense}
                        onChange={(e) => handleProfileSettingChange('tradeLicense', e.target.value)}
                      />
                    </Grid>
                    
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="ব্যাংক অ্যাকাউন্ট নম্বর"
                        value={profileSettings.bankAccount}
                        onChange={(e) => handleProfileSettingChange('bankAccount', e.target.value)}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </StyledCard>
            </Grid>
          </Grid>
        </TabPanel>

        {/* Notifications Tab */}
        <TabPanel value={activeTab} index={2}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <StyledCard>
                <CardHeader 
                  title="নোটিফিকেশন সেটিংস"
                  avatar={<Avatar sx={{ bgcolor: 'info.main' }}><NotificationsIcon /></Avatar>}
                />
                <CardContent>
                  <List>
                    <ListItem>
                      <ListItemIcon><EmailIcon /></ListItemIcon>
                      <ListItemText primary="ইমেইল নোটিফিকেশন" secondary="গুরুত্বপূর্ণ আপডেট ইমেইলে পান" />
                      <ListItemSecondaryAction>
                        <Switch 
                          checked={notificationSettings.emailNotifications}
                          onChange={() => handleNotificationChange('emailNotifications')}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                    
                    <ListItem>
                      <ListItemIcon><MobileIcon /></ListItemIcon>
                      <ListItemText primary="SMS নোটিফিকেশন" secondary="অর্ডার আপডেট SMS এ পান" />
                      <ListItemSecondaryAction>
                        <Switch 
                          checked={notificationSettings.smsNotifications}
                          onChange={() => handleNotificationChange('smsNotifications')}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                    
                    <ListItem>
                      <ListItemIcon><NotificationsIcon /></ListItemIcon>
                      <ListItemText primary="Push নোটিফিকেশন" secondary="রিয়েল-টাইম আপডেট পান" />
                      <ListItemSecondaryAction>
                        <Switch 
                          checked={notificationSettings.pushNotifications}
                          onChange={() => handleNotificationChange('pushNotifications')}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                  </List>
                </CardContent>
              </StyledCard>
            </Grid>

            <Grid item xs={12} md={6}>
              <StyledCard>
                <CardHeader title="বিশেষ নোটিফিকেশন" />
                <CardContent>
                  <List>
                    <ListItem>
                      <ListItemText primary="নতুন অর্ডার" secondary="নতুন অর্ডার পেলে জানান" />
                      <ListItemSecondaryAction>
                        <Switch 
                          checked={notificationSettings.orderNotifications}
                          onChange={() => handleNotificationChange('orderNotifications')}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                    
                    <ListItem>
                      <ListItemText primary="পেমেন্ট আপডেট" secondary="পেমেন্ট সংক্রান্ত তথ্য" />
                      <ListItemSecondaryAction>
                        <Switch 
                          checked={notificationSettings.paymentNotifications}
                          onChange={() => handleNotificationChange('paymentNotifications')}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                    
                    <ListItem>
                      <ListItemText primary="স্টক সতর্কতা" secondary="কম স্টক হলে জানান" />
                      <ListItemSecondaryAction>
                        <Switch 
                          checked={notificationSettings.stockAlerts}
                          onChange={() => handleNotificationChange('stockAlerts')}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                  </List>
                </CardContent>
              </StyledCard>
            </Grid>
          </Grid>
        </TabPanel>

        {/* Payment Methods Tab */}
        <TabPanel value={activeTab} index={3}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <StyledCard>
                <CardHeader 
                  title="পেমেন্ট পদ্ধতি"
                  avatar={<Avatar sx={{ bgcolor: 'success.main' }}><PaymentIcon /></Avatar>}
                  action={
                    <Button
                      variant="contained"
                      startIcon={<AddIcon />}
                      onClick={() => setOpenPaymentDialog(true)}
                    >
                      নতুন যোগ করুন
                    </Button>
                  }
                />
                <CardContent>
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>পদ্ধতি</TableCell>
                          <TableCell>নম্বর/অ্যাকাউন্ট</TableCell>
                          <TableCell>স্ট্যাটাস</TableCell>
                          <TableCell>প্রাথমিক</TableCell>
                          <TableCell align="center">অ্যাকশন</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {paymentMethods.map((method) => (
                          <TableRow key={method.id}>
                            <TableCell>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <span style={{ fontSize: '20px' }}>{getPaymentMethodIcon(method.type)}</span>
                                {getPaymentMethodName(method.type)}
                              </Box>
                            </TableCell>
                            <TableCell>
                              {method.number || method.accountNumber}
                              {method.bankName && (
                                <Typography variant="caption" display="block" color="text.secondary">
                                  {method.bankName}
                                </Typography>
                              )}
                            </TableCell>
                            <TableCell>
                              <Chip 
                                label={method.status === 'verified' ? 'ভেরিফাইড' : 'পেন্ডিং'}
                                color={method.status === 'verified' ? 'success' : 'warning'}
                                size="small"
                                icon={method.status === 'verified' ? <VerifiedIcon /> : <WarningIcon />}
                              />
                            </TableCell>
                            <TableCell>
                              {method.primary && <Badge color="primary" badgeContent="প্রাথমিক" />}
                            </TableCell>
                            <TableCell align="center">
                              <IconButton size="small" color="primary">
                                <EditIcon />
                              </IconButton>
                              <IconButton size="small" color="error">
                                <DeleteIcon />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </CardContent>
              </StyledCard>
            </Grid>
          </Grid>
        </TabPanel>

        {/* Delivery Settings Tab */}
        <TabPanel value={activeTab} index={4}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <StyledCard>
                <CardHeader 
                  title="ডেলিভারি সেটিংস"
                  avatar={<Avatar sx={{ bgcolor: 'info.main' }}><ShippingIcon /></Avatar>}
                />
                <CardContent>
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="ডেলিভারি এলাকা (কিলোমিটার)"
                        type="number"
                        value={storeSettings.deliveryRadius}
                        onChange={(e) => handleStoreSettingChange('deliveryRadius', e.target.value)}
                      />
                    </Grid>
                    
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="সর্বনিম্ন অর্ডার পরিমাণ (৳)"
                        type="number"
                        value={storeSettings.minOrderAmount}
                        onChange={(e) => handleStoreSettingChange('minOrderAmount', e.target.value)}
                      />
                    </Grid>
                    
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="ডেলিভারি চার্জ (৳)"
                        type="number"
                        value={storeSettings.deliveryCharge}
                        onChange={(e) => handleStoreSettingChange('deliveryCharge', e.target.value)}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </StyledCard>
            </Grid>

            <Grid item xs={12} md={6}>
              <StyledCard>
                <CardHeader title="ডেলিভারি এলাকা" />
                <CardContent>
                  <Typography variant="body2" color="text.secondary" gutterBottom>
                    আপনার দোকান থেকে {storeSettings.deliveryRadius} কিলোমিটার পর্যন্ত ডেলিভারি
                  </Typography>
                  
                  <Box sx={{ 
                    height: 200, 
                    bgcolor: '#f5f5f5', 
                    borderRadius: 2, 
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '2px dashed #ddd'
                  }}>
                    <Typography variant="body2" color="text.secondary">
                      🗺️ ডেলিভারি এলাকার ম্যাপ এখানে দেখা যাবে
                    </Typography>
                  </Box>
                </CardContent>
              </StyledCard>
            </Grid>
          </Grid>
        </TabPanel>

        {/* Security Tab */}
        <TabPanel value={activeTab} index={5}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <StyledCard>
                <CardHeader 
                  title="পাসওয়ার্ড ও নিরাপত্তা"
                  avatar={<Avatar sx={{ bgcolor: 'error.main' }}><SecurityIcon /></Avatar>}
                />
                <CardContent>
                  <List>
                    <ListItem>
                      <ListItemText 
                        primary="পাসওয়ার্ড পরিবর্তন করুন"
                        secondary="শেষবার পরিবর্তন: ১৫ দিন আগে"
                      />
                      <Button 
                        variant="outlined" 
                        onClick={() => setOpenPasswordDialog(true)}
                      >
                        পরিবর্তন
                      </Button>
                    </ListItem>
                    
                    <Divider />
                    
                    <ListItem>
                      <ListItemText 
                        primary="দুই-ধাপ যাচাইকরণ"
                        secondary="অতিরিক্ত নিরাপত্তার জন্য সক্রিয় করুন"
                      />
                      <Switch defaultChecked />
                    </ListItem>
                    
                    <ListItem>
                      <ListItemText 
                        primary="লগইন সতর্কতা"
                        secondary="নতুন ডিভাইস থেকে লগইন হলে জানান"
                      />
                      <Switch defaultChecked />
                    </ListItem>
                  </List>
                </CardContent>
              </StyledCard>
            </Grid>

            <Grid item xs={12} md={6}>
              <StyledCard>
                <CardHeader title="সাম্প্রতিক কার্যক্রম" />
                <CardContent>
                  <List dense>
                    <ListItem>
                      <ListItemText 
                        primary="সফল লগইন"
                        secondary="আজ ১০:৩০ AM - Chrome ব্রাউজার"
                      />
                    </ListItem>
                    <ListItem>
                      <ListItemText 
                        primary="পাসওয়ার্ড পরিবর্তন"
                        secondary="১৫ দিন আগে"
                      />
                    </ListItem>
                    <ListItem>
                      <ListItemText 
                        primary="নতুন ডিভাইস যোগ"
                        secondary="২০ দিন আগে - মোবাইল অ্যাপ"
                      />
                    </ListItem>
                  </List>
                </CardContent>
              </StyledCard>
            </Grid>
          </Grid>
        </TabPanel>
      </StyledPaper>

      {/* Password Change Dialog */}
      <Dialog 
        open={openPasswordDialog} 
        onClose={() => setOpenPasswordDialog(false)}
        maxWidth="sm" 
        fullWidth
        disableScrollLock={true}
      >
        <DialogTitle>পাসওয়ার্ড পরিবর্তন করুন</DialogTitle>
        <DialogContent>
          <Grid container spacing={3} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="বর্তমান পাসওয়ার্ড"
                type={showPassword ? 'text' : 'password'}
                InputProps={{
                  endAdornment: (
                    <IconButton onClick={() => setShowPassword(!showPassword)}>
                      {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                    </IconButton>
                  )
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="নতুন পাসওয়ার্ড"
                type={showPassword ? 'text' : 'password'}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="নতুন পাসওয়ার্ড নিশ্চিত করুন"
                type={showPassword ? 'text' : 'password'}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenPasswordDialog(false)}>বাতিল</Button>
          <Button 
            variant="contained" 
            onClick={() => {
              setOpenPasswordDialog(false);
              handleSaveSettings('পাসওয়ার্ড');
            }}
          >
            পরিবর্তন করুন
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Alert
          onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default Settings;
